<template>
  <div>
    <div class="toolbar">
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:200px" @change="load">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-input v-model="keyword" clearable placeholder="模板名称" style="width:200px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增模板</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="name" label="模板名称" min-width="160" />
      <el-table-column prop="supplierName" label="供应商" min-width="140" />
      <el-table-column prop="enabled" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled === 1 ? 'success' : 'info'">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id ? '编辑材料申请模板' : '新增材料申请模板'" :visible.sync="visible" width="900px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="模板名称" required>
          <el-input v-model="form.name" maxlength="128" />
        </el-form-item>
        <el-form-item label="供应商" required>
          <el-select v-model="form.supplierId" filterable placeholder="选择供应商" style="width:100%">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="材料明细" required>
          <el-button size="mini" type="primary" plain @click="openPickMaterial">选择材料</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="materialName" label="材料" min-width="140" show-overflow-tooltip />
            <el-table-column prop="specs" label="规格" width="120" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.specs || '-' }}</template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" width="70" align="center" />
            <el-table-column label="数量" width="130">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.qty"
                  :min="0.01"
                  :precision="2"
                  size="mini"
                  controls-position="right"
                  style="width:100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="140">
              <template slot-scope="{ row }">
                <el-input v-model="row.remark" size="mini" placeholder="选填" />
              </template>
            </el-table-column>
            <el-table-column width="70">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.lines.splice($index,1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择材料"
      :visible.sync="pickVisible"
      width="760px"
      append-to-body
      @closed="onPickClosed"
    >
      <div class="pick-toolbar">
        <el-input
          v-model="pickKeyword"
          clearable
          placeholder="名称 / 规格 / 分类"
          style="width:240px"
          @keyup.enter.native="loadPickList"
        />
        <el-button type="primary" icon="el-icon-search" @click="loadPickList">查询</el-button>
      </div>
      <el-table
        ref="pickTable"
        :data="pickPageList"
        border
        size="small"
        row-key="id"
        v-loading="pickLoading"
        max-height="420"
        @selection-change="onPickSelectionChange"
      >
        <el-table-column type="selection" width="45" :selectable="pickSelectable" reserve-selection />
        <el-table-column prop="name" label="材料名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="分类" width="110" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.categoryName || row.category || '-' }}</template>
        </el-table-column>
        <el-table-column prop="spec" label="规格" width="110" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" align="center" />
      </el-table>
      <list-pagination
        :total="pickTotal"
        :page="pickPage"
        :page-size="pickPageSize"
        @current-change="onPickPageChange"
        @size-change="onPickPageSizeChange"
      />
      <div slot="footer">
        <el-button @click="pickVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmPickMaterials">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMaterialReqTpls,
  getMaterialReqTpl,
  saveMaterialReqTpl,
  deleteMaterialReqTpl,
  listSuppliers,
  listMaterials
} from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'MaterialReqTpl',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      supplierId: null,
      suppliers: [],
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: { lines: [] },
      pickVisible: false,
      pickKeyword: '',
      pickList: [],
      pickLoading: false,
      pickPage: 1,
      pickPageSize: 15,
      pickSelection: []
    }
  },
  computed: {
    selectedMaterialIds() {
      return new Set((this.form.lines || []).map(l => l.materialId).filter(Boolean))
    },
    pickTotal() {
      return (this.pickList || []).length
    },
    pickPageList() {
      const list = this.pickList || []
      const start = (this.pickPage - 1) * this.pickPageSize
      return list.slice(start, start + this.pickPageSize)
    }
  },
  created() {
    this.loadSuppliers()
    this.load()
  },
  methods: {
    async loadSuppliers() {
      const res = await listSuppliers({})
      this.suppliers = (res.data || []).filter(s => s.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReqTpls({
          keyword: this.keyword || undefined,
          supplierId: this.supplierId || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    lineFromMaterial(m) {
      return {
        materialId: m.id,
        materialName: m.name || '',
        specs: m.spec || '',
        unit: m.unit || '',
        qty: 1,
        remark: ''
      }
    },
    async openPickMaterial() {
      this.pickKeyword = ''
      this.pickSelection = []
      this.pickPage = 1
      this.pickVisible = true
      await this.loadPickList()
    },
    async loadPickList() {
      this.pickLoading = true
      try {
        const res = await listMaterials({ keyword: this.pickKeyword || undefined })
        this.pickList = (res.data || []).filter(m => m.enabled !== 0)
        this.pickPage = 1
        this.pickSelection = []
        this.$nextTick(() => {
          if (this.$refs.pickTable) this.$refs.pickTable.clearSelection()
        })
      } finally {
        this.pickLoading = false
      }
    },
    pickSelectable(row) {
      return !this.selectedMaterialIds.has(row.id)
    },
    onPickSelectionChange(rows) {
      this.pickSelection = rows || []
    },
    onPickPageChange(p) {
      this.pickPage = p
    },
    onPickPageSizeChange(s) {
      this.pickPageSize = s
      this.pickPage = 1
    },
    onPickClosed() {
      this.pickSelection = []
      this.pickList = []
    },
    confirmPickMaterials() {
      const selected = this.pickSelection || []
      if (!selected.length) {
        return this.$message.warning('请先勾选材料')
      }
      let added = 0
      selected.forEach(m => {
        if (!m || !m.id || this.selectedMaterialIds.has(m.id)) return
        this.form.lines.push(this.lineFromMaterial(m))
        added += 1
      })
      if (!added) {
        return this.$message.warning('所选材料已在明细中')
      }
      this.pickVisible = false
      this.$message.success(`已添加 ${added} 个材料`)
    },
    async openEdit(row) {
      if (row && row.id) {
        const res = await getMaterialReqTpl(row.id)
        const d = res.data || {}
        this.form = {
          id: d.id,
          name: d.name,
          supplierId: d.supplierId,
          remark: d.remark || '',
          enabled: d.enabled == null ? 1 : d.enabled,
          lines: (d.lines || []).map(l => ({
            materialId: l.materialId,
            materialName: l.materialName || '',
            specs: l.specs || l.spec || '',
            unit: l.unit || '',
            qty: l.qty == null ? 1 : Number(l.qty),
            remark: l.remark || ''
          }))
        }
      } else {
        this.form = {
          id: null,
          name: '',
          supplierId: this.supplierId || null,
          remark: '',
          enabled: 1,
          lines: []
        }
      }
      this.visible = true
    },
    async save() {
      if (!this.form.name || !this.form.supplierId) return this.$message.warning('请填写模板名称和供应商')
      if (!this.form.lines || !this.form.lines.some(l => l.materialId)) {
        return this.$message.warning('请至少添加一行材料')
      }
      this.saving = true
      try {
        await saveMaterialReqTpl({
          id: this.form.id,
          name: this.form.name,
          supplierId: this.form.supplierId,
          remark: this.form.remark,
          enabled: this.form.enabled,
          lines: this.form.lines
            .filter(l => l.materialId)
            .map(l => ({
              materialId: l.materialId,
              specs: l.specs || undefined,
              qty: Number(l.qty) > 0 ? Number(l.qty) : 1,
              remark: l.remark
            }))
        })
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteMaterialReqTpl(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.pick-toolbar { display:flex; gap:8px; margin-bottom:12px; }
.tip { margin:8px 0 0; color:#94a3b8; font-size:12px; }
</style>
